export default {
  graphqlEndpoint: 'https://symypokwszcrdho27peypzewdi.appsync-api.us-east-1.amazonaws.com/graphql',
  region: 'es-east-1',
  authenticationType: 'AMAZON_COGNITO_USER_POOLS'
}